import { render, staticRenderFns } from "./OverlayProduct.vue?vue&type=template&id=0b67cca8&"
import script from "./OverlayProduct.vue?vue&type=script&lang=js&"
export * from "./OverlayProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b67cca8')) {
      api.createRecord('0b67cca8', component.options)
    } else {
      api.reload('0b67cca8', component.options)
    }
    module.hot.accept("./OverlayProduct.vue?vue&type=template&id=0b67cca8&", function () {
      api.rerender('0b67cca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayProduct.vue"
export default component.exports